import { render, staticRenderFns } from "./TitleName.vue?vue&type=template&id=1aa064c2&scoped=true&"
import script from "./TitleName.vue?vue&type=script&lang=ts&"
export * from "./TitleName.vue?vue&type=script&lang=ts&"
import style0 from "./TitleName.vue?vue&type=style&index=0&id=1aa064c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa064c2",
  null
  
)

export default component.exports